import { $user } from 'state/stores/user';
import { UserDetail } from 'types/user';
import * as Yup from 'yup';

export const deliveryOptions = [
  {
    name: 'deliveryOptions.pickup',
    label: `Pickup`,
  },
  {
    name: 'deliveryOptions.delivery',
    label: `Delivery`,
  },
  {
    name: 'deliveryOptions.publicMeetup',
    label: 'Public Meetup',
  },
];

export const generateInitialData = (userDetail: UserDetail) => {
  const savedData = localStorage.getItem('item-data') ?? '{}';
  const parsedData = JSON.parse(savedData);
  const location = $user.selectors.useLocation();
  return {
    title: '',
    category: '',
    subCategory: '',
    modelNumber: '',
    serialNumber: '',
    guidelines: '',
    address: userDetail?.userDetails?.address ?? '',
    description: '',
    rentalPrice: '',
    photos: [],
    state: location.stateId,
    location: location.cityId,
    ownersManual: '',
    featuredPhoto: '',
    includedInRental: [],
    termsAndConditions: false,
    deliveryOptions: {
      pickup: false,
      delivery: false,
      publicMeetup: false,
    },
    weeklySchedule: {
      '0': { am: false, pm: false },
      '1': { am: false, pm: false },
      '2': { am: false, pm: false },
      '3': { am: false, pm: false },
      '4': { am: false, pm: false },
      '5': { am: false, pm: false },
      '6': { am: false, pm: false },
    },
    ...parsedData,
  };
};

export const initialValues = {
  title: '',
  category: '',
  subCategory: '',
  modelNumber: '',
  serialNumber: '',
  guidelines: '',
  address: '',
  description: '',
  rentalPrice: '',
  photos: [],
  location: '',
  ownersManual: '',
  featuredPhoto: '',
  includedInRental: [],
  termsAndConditions: false,
  deliveryOptions: {
    pickup: false,
    delivery: false,
    publicMeetup: false,
  },
  weeklySchedule: {
    '0': { am: false, pm: false },
    '1': { am: false, pm: false },
    '2': { am: false, pm: false },
    '3': { am: false, pm: false },
    '4': { am: false, pm: false },
    '5': { am: false, pm: false },
    '6': { am: false, pm: false },
  },
};

const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];

export const validationSchema = Yup.object().shape({
  title: Yup.string().max(70).required('Title is required'),
  category: Yup.string().required('Category is required'),
  state: Yup.string().required('State is required'),
  location: Yup.string().required('City is required'),
  subCategory: Yup.string().required('Sub category is required'),
  modelNumber: Yup.string().required('Model Number is required'),
  rentalPrice: Yup.number()
    .required('Rental Price is required')
    .min(1, 'Minimum price is $1')
    .max(250, 'Maximum price is $250'),
  deliveryOptions: Yup.object()
    .shape({
      pickup: Yup.boolean(),
      delivery: Yup.boolean(),
      publicMeetup: Yup.boolean(),
    })
    .test(
      'at-least-one-true',
      'At least one option should be selected',
      (options) => options.pickup || options.delivery || options.publicMeetup,
    ),
  description: Yup.string().max(500).required('Description is required'),
  weeklySchedule: Yup.object()
    .shape({
      '0': Yup.object().shape({
        am: Yup.boolean(),
        pm: Yup.boolean(),
      }),
      '1': Yup.object().shape({
        am: Yup.boolean(),
        pm: Yup.boolean(),
      }),
      '2': Yup.object().shape({
        am: Yup.boolean(),
        pm: Yup.boolean(),
      }),
      '3': Yup.object().shape({
        am: Yup.boolean(),
        pm: Yup.boolean(),
      }),
      '4': Yup.object().shape({
        am: Yup.boolean(),
        pm: Yup.boolean(),
      }),
      '5': Yup.object().shape({
        am: Yup.boolean(),
        pm: Yup.boolean(),
      }),
      '6': Yup.object().shape({
        am: Yup.boolean(),
        pm: Yup.boolean(),
      }),
    })
    .test(
      'at-least-one-slot-available',
      'At least one time slot should be available',
      (schedule) => {
        return Object.values(schedule).some((day) =>
          Object.values(day).some((slot) => slot === true),
        );
      },
    ),
});
